/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, discrepancies: NonNullable<unknown> }} Audit_Complete_With_DiscrepanciesInputs */

const en_audit_complete_with_discrepancies = /** @type {(inputs: Audit_Complete_With_DiscrepanciesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audit complete — ${i?.count} items checked, ${i?.discrepancies} discrepancy(ies) found`)
};

const es_audit_complete_with_discrepancies = /** @type {(inputs: Audit_Complete_With_DiscrepanciesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auditoria completa — ${i?.count} articulos verificados, ${i?.discrepancies} discrepancia(s) encontrada(s)`)
};

/**
* | output |
* | --- |
* | "Audit complete — {count} items checked, {discrepancies} discrepancy(ies) found" |
*
* @param {Audit_Complete_With_DiscrepanciesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_complete_with_discrepancies = /** @type {((inputs: Audit_Complete_With_DiscrepanciesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Complete_With_DiscrepanciesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_complete_with_discrepancies(inputs)
	return es_audit_complete_with_discrepancies(inputs)
});